<template>
    <modal-dialog
        ref="dialog"
        label="E-mail verzonden"
        description="E-mail verzonden"
        :size="5"
    >
        <flex-container
            gap="md"
        >
            <flex-container
                direction="column"
                gap="xs"
            >
                <text-heading>{{ props.email.subject }}</text-heading>
                <text-decorator size="sm" color="gray-500">
                    <strong>Aan: </strong>
                    <span>{{ props.email.recipient }}</span>
                </text-decorator>
                <text-decorator size="sm" color="gray-500">
                    <strong>Verzonden op: </strong>
                    <span>{{ formatDate(props.email.createdAt) }}</span>
                </text-decorator>
            </flex-container>
            <flex-container>
                <iframe
                    :srcdoc="props.email.body"
                    class="email-body"
                    title="Verzonden e-mail"
                />
            </flex-container>
        </flex-container>
    </modal-dialog>
</template>

<script setup lang="ts">
    import { ref } from 'vue';
    import type { ExposedOverlay } from '@keyvue/one-ui';
    import type { ChatEmail } from '@keyvue/one-api-client';
    import dayjs from 'dayjs';

    const props = defineProps<{
        email: ChatEmail,
    }>();

    const dialog = ref<ExposedOverlay>();

    function formatDate(date: Date) {
        return dayjs(date).format('DD MMMM YYYY om HH:mm');
    }

    defineExpose({
        overlay: dialog,
    });
</script>

<style scoped lang="scss">
    .email-body {
        border: none;
        width: 100%;
        min-height: 60vh;
    }
</style>
